export default __webpack_public_path__ + "static/media/pic1.7f50cfc2.jpg";